import getTranslationFromTransportType
    from "@SearchResults/features/staticContent/functions/getTranslationFromTransportType";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import {RoutesOrganizedByTransportTypeType} from "@SearchResults/types/RoutesOrganizedByTransportType.type";
import {isLastElement} from "@Array/isLastElement";
import {RouteTransferTypeKeys} from "@Route/features/transportType/types/routeTransferType.type";
import {
    TicketsSoldByTransportTypeType
} from "@SearchResults/features/staticContent/types/TicketsSoldByTransportType.type";

export default function createMostPopularDataStats(
    ticketsSoldByTransportType: TicketsSoldByTransportTypeType,
    transportTypes: TransportTypesType[],
    singleRoutes: RoutesOrganizedByTransportTypeType
) {
    const map: Record<RouteTransferTypeKeys, TransportTypesType> = {
        1: "bus",
        2: "ferry",
        3: "train",
        4: "plane",
        5: "privateTransfer",
    }

    const prepareData = (
        ticketsSoldByTransportType: { type: TransportTypesType, count: number }[],
        totalTicketsSold: number
    ) => {
        let percentageSum = 0

        return ticketsSoldByTransportType.map(({type, count}, index) => {
            const percentageForType = Math.floor((count / totalTicketsSold) * 100)
            percentageSum += percentageForType

            const shouldAppendLostPercentage = isLastElement(ticketsSoldByTransportType, index) && (100 - percentageSum)

            return ({
                type: getTranslationFromTransportType(type),
                count: `${shouldAppendLostPercentage ? percentageForType + (100 - percentageSum) : percentageForType}%`,
            })
        })
    }
    const makeDataFromRouteByTypeDistribution = () => {
        const numberOfRoutes = transportTypes.map((transportType) => (
            singleRoutes[transportType].length
        ))

        const totalNumberOfRoutes = numberOfRoutes.reduce((partialSum, routeCount) => (
            routeCount + partialSum
        ), 0)

        const madeTicketsSoldByTransportType = transportTypes.map((transportType, index) => ({
            type: transportType,
            count: numberOfRoutes[index],
        }))

        return prepareData(madeTicketsSoldByTransportType, totalNumberOfRoutes)
    }
    const getTotalTicketsSold = () => (
        ticketsSoldByTransportType.reduce((sum, {count}) => (
            sum + count
        ), 0)
    )

    const mapTypes = () => (
        ticketsSoldByTransportType.map(({transportTypeId, count}) => ({
            type: map[transportTypeId],
            count,
        }))
    )

    return {
        preparedTicketsSoldByTransportType: ticketsSoldByTransportType.length === 0
            ? makeDataFromRouteByTypeDistribution()
            : prepareData(mapTypes(), getTotalTicketsSold()),
    }
}